export const englishData = {
  departmentName: "Department of English",
  bannerImage: "/infrastructure/english/class-1.JPG",

  about: {
    title: "About the Department",
    content: `The Department of English at Rayalaseema University is dedicated to fostering literary appreciation, 
    critical thinking, and effective communication skills. Our department offers comprehensive programs in English 
    literature, linguistics, and language pedagogy. We emphasize analytical reading, creative writing, and research 
    in various literary traditions, preparing students for careers in education, media, publishing, and corporate sectors.`,
    highlights: [
      "Rich collection in departmental library",
      "Literary club and cultural activities",
      "Regular seminars and workshops on literature and linguistics",
      "Focus on both classical and contemporary literature"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/english/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {

    name: "Dr. P. Sreenivasulu",
    designation: "Co-ordinator & Assistant Professor (C)",
    email: "srinivasulupurohitam3706@gmail.com",
    mobile: "9440035438",
    photo: "/telugu/sreenivasulu.JPG",
    profileLink: "/telugu/SREENIVASULU.pdf",
    qualification: "M.A (Telugu),  Ph.D",
    specialization: "Folk and old Literature and Sanskrit",
    message: `Welcome to the Department of English at Rayalaseema University. We are committed to excellence in 
    English education and research. Our department provides a stimulating environment for students to explore the 
    fascinating world of English literature and language. Join us in enhancing your literary skills and critical 
    thinking abilities.`,

  },

  bos: {
  title: "English",
  members: [
    {
      name: "Principal, RU College",
      designation: "Chairperson",
      affiliation: "Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. K. Suman Kiran",
      designation: "Member",
      affiliation: "Dept. of English, S.V. University, Tirupati"
    },
    {
      name: "Prof. P. Padma",
      designation: "Member",
      affiliation: "Dept. of English, Yogi Vemana University, Kadapa"
    },
    {
      name: "Prof. N. Narasimhulu",
      designation: "Member",
      affiliation: "Head Incharge, Dept. of Telugu, Rayalaseema University, Kurnool"
    }
  ]
}
,

  faculty: [
    // {
    //   name: "Prof. Mary Elizabeth",
    //   designation: "Professor & Head",
    //   email: "mary.elizabeth@ruk.ac.in",
    //   mobile: "+91 98765 43223",
    //   photo: "/english/mary-elizabeth.JPG",
    //   qualification: "M.A., Ph.D.",
    //   specialization: "Victorian Literature, Postcolonial Studies",
    //   profileLink: "/english/MARY-ELIZABETH.pdf"
    // },
    // {
    //   name: "Dr. David Johnson",
    //   designation: "Associate Professor",
    //   email: "david.johnson@ruk.ac.in",
    //   mobile: "+91 98765 43224",
    //   photo: "/english/david-johnson.JPG",
    //   qualification: "M.A., Ph.D.",
    //   specialization: "American Literature, Literary Theory",
    //   profileLink: "/english/DAVID-JOHNSON.pdf"
    // },
    // {
    //   name: "Dr. Anjali Gupta",
    //   designation: "Assistant Professor",
    //   email: "anjali.gupta@ruk.ac.in",
    //   mobile: "+91 98765 43225",
    //   photo: "/english/anjali-gupta.JPG",
    //   qualification: "M.A., Ph.D.",
    //   specialization: "Indian Writing in English, Women's Studies",
    //   profileLink: "/english/ANJALI-GUPTA.pdf"
    // },
    // {
    //   name: "Dr. Ravi Shankar",
    //   designation: "Assistant Professor",
    //   email: "ravi.shankar@ruk.ac.in",
    //   mobile: "+91 98765 43226",
    //   photo: "/english/ravi-shankar.JPG",
    //   qualification: "M.A., Ph.D.",
    //   specialization: "Linguistics, English Language Teaching",
    //   profileLink: "/english/RAVI-SHANKAR.pdf"
    // }
  ],

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.A. English",
    //     duration: "3 Years",
    //     eligibility: "10+2 in any stream",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.A. English",
        duration: "2 Years",
        eligibility: "B.A. with English",
        intake: "30 seats"
      }
    ],
    // research: [
    //   {
    //     name: "Ph.D. in English",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.A. English with qualifying exam",
    //     areas: "British Literature, American Literature, Indian Writing in English, Literary Criticism, Linguistics"
    //   }
    // ]
  },

  Infrastructure: [
    "/infrastructure/english/class-1.JPG",
    "/infrastructure/english/class-2.JPG",

    "/infrastructure/english/lab-1.JPG",

  ]
};
